import React, { Component } from "react";
import { withRouter, Link, Redirect } from "react-router-dom";
import history from "./history";
import update from "react-addons-update";
import * as Scales from "./scales";
import * as Session from "./session";
import * as Questions from "./questions";
import { Report } from "./Report";
import { addSurveyToFireStore } from "./Config/config";
import ReactGA from "react-ga";

class SubSectionTestPage extends Component {
  constructor(props) {
    super(props);
    ReactGA.pageview(window.location.pathname + window.location.search);
    // console.log(props)
    let data = SubSectionTestPage.loadDataForState(props);
    // console.log({data})
    this.state = {
      sector: data.sector,
      section: data.section || {},
      subSection: data.subSection || {},
      stage: data.stage || {},
      scaleItems: Scales.Options,
      __isSaving: false,
      __savingErrorOccurred: false
    };
  }

  static loadDataForState(props = {}) {
    let {
      userEmail,
      sectorId,
      sectionOffset,
      subSectionOffset
    } = props.match.params;
    if (!userEmail && sectorId) {
      Session.updateSectorIfRequired(sectorId);
    }
    console.log(Session.currentSession);
    let sector = Session.currentSession.responses;
    let section = sector ? sector.sections[sectionOffset] : undefined;
    let subSection =
      section && section.subSections
        ? section.subSections[subSectionOffset]
        : undefined;
    return {
      sector: sector,
      section: section,
      subSection: subSection
    };
  }

  componentWillReceiveProps(nextProps) {
    ReactGA.pageview(window.location.pathname + window.location.search);
    let data = SubSectionTestPage.loadDataForState(nextProps);
    // console.log({nextProps}, {data})
    this.setState({
      sector: data.sector,
      section: data.section,
      subSection: data.subSection,
      scaleItems: Scales.Options
    });
  }

  nextUrl() {
    let {
      userEmail,
      sectorId,
      sectionOffset,
      subSectionOffset
    } = this.props.match.params;
    let currentOffsets = Questions.parseOffsets({
      sectionOffset,
      subSectionOffset
    });
    let nextOffsets = Questions.nextSubSection(
      this.state.sector,
      currentOffsets
    );
    if (nextOffsets)
      return `/user/${userEmail}/section/${
        nextOffsets.sectionOffset
      }/subsection/${nextOffsets.subSectionOffset}`;
    else return Session.thankYouUrl(userEmail);
  }

  markSessionAsFinishedInParallel() {
    let { userEmail } = this.props.match.params;
    Session.currentSession.isFinished = true;
    Session.saveCurrentSession(userEmail);
  }

  transitionToNextUrl(url) {
    this.props.history.push(url);
    window.scrollTo(0, 0);
  }

  tryGoingToNextPage() {
    let { userEmail } = this.props.match.params;
    let nextUrl = this.nextUrl();
    if (Questions.allQuestionsInSubSectionAreAnswered(this.state.subSection)) {
      if (nextUrl === Session.thankYouUrl(userEmail)) {
        this.markSessionAsFinishedInParallel();
      }
      this.transitionToNextUrl(nextUrl);
    } else {
      alert(`Falta a responder a pelo menos uma das questões`);
    }
  }

  previousUrl() {
    const {
      userEmail,
      sectorId,
      sectionOffset,
      subSectionOffset
    } = this.props.match.params;
    const currentOffsets = Questions.parseOffsets({
      sectionOffset,
      subSectionOffset
    });
    const previousOffsets = Questions.prevSubSection(
      this.state.sector,
      currentOffsets
    );
    if (previousOffsets)
      return `/user/${userEmail}/section/${
        previousOffsets.sectionOffset
      }/subsection/${previousOffsets.subSectionOffset}`;
    else return Session.registerUrl();
  }

  goToPreviousPage() {
    const previousUrl = this.previousUrl();
    this.props.history.push(previousUrl);
  }

  onResponseChange(stage, stageOffset, question, questionOffset, value) {
    console.log(
      `Updating question at ${questionOffset} for stage at ${stageOffset}`
    );

    // updates Session object
    question.response = value;
    // calculate score for level of the tree
    Questions.scoreTree(Session.currentSession.responses, Scales.Options);
    // console.log(Session.currentSession.responses)
    // update UI state
    let subSection = update(this.state.subSection, {
      stages: {
        [stageOffset]: {
          questions: {
            [questionOffset]: {
              $merge: {
                response: value
              }
            }
          }
        }
      }
    });
    this.setState(
      {
        subSection
      },
      this.handleSurveySave
    );
  }

  handleSurveySave() {
    if (!Session.isInitiated()) return;
    this.setState({ __isSaving: true, __savingErrorOccurred: false }, () => {
      addSurveyToFireStore(
        Session.currentSession.contactEmail,
        Session.currentSession
      )
        .then(response => {
          this.setState({ __isSaving: false });
        })
        .catch(error => {
          console.log("Got an error: ", error);
          this.setState({ __savingErrorOccurred: true });
        });
    });
  }

  render() {
    if (!this.state.sector)
      return <Redirect to={`/user/${this.props.match.params.userEmail}`} />;
    else
      return (
        <div>
          {this.state.subSection.subTitle && (
            <p
              className="lead alert alert-success"
              style={{ textShadow: "none" }}
            >
              {this.state.subSection.subTitle}
            </p>
          )}
          {this.state.subSection.stages.map((stage, stageOffset) => (
            <StageItem
              key={stageOffset}
              subSection={this.state.subSection}
              stage={stage}
              stageOffset={stageOffset}
              scaleItems={this.state.scaleItems}
              onChange={this.onResponseChange.bind(this, stage, stageOffset)}
            />
          ))}
          <div className="clearfix">
            <button
              className="btn btn-primary float-right"
              onClick={this.tryGoingToNextPage.bind(this)}
            >
              Avançar
            </button>
            <button
              className="btn btn-primary float-left"
              onClick={this.goToPreviousPage.bind(this)}
            >
              Recuar
            </button>
          </div>
          <div style={{ height: "10em" }} />
        </div>
      );
  }
}

export default withRouter(SubSectionTestPage);

const PageTitle = props => (
  <h4 style={props.style}>
    {props.section.title}
    {props.subSection.title && <span> &mdash; {props.subSection.title}</span>}
  </h4>
);

const StageItem = props => (
  <div style={{ marginTop: "2em" }}>
    <StageTitle text={props.stage.title} />
    <QuestionTable
      subSection={props.subSection}
      stageOffset={props.stageOffset}
      questions={props.stage.questions}
      scaleItems={props.scaleItems}
      onChange={props.onChange.bind(this)}
    />
  </div>
);

const StageTitle = props => (
  <div style={{ marginBottom: "1em" }}>{props.text}</div>
);

const QuestionTable = props => (
  <table className="table">
    <tbody>
      {props.questions.map((question, questionOffset) => {
        return [
          <QuestionRow
            key={`question-${questionOffset}`}
            number={
              Questions.offsetOfQuestionInSubSection(
                props.subSection,
                props.stageOffset,
                questionOffset
              ) + 1
            }
            question={question}
          />,
          <ScaleRow
            key={`scale-${questionOffset}`}
            group={`${props.stageOffset}-${questionOffset}`}
            scaleItems={props.scaleItems}
            scaleValue={question.response}
            onChange={props.onChange.bind(this, question, questionOffset)}
          />
        ];
      })}
    </tbody>
  </table>
);

const QuestionRow = props => (
  <tr>
    <td colSpan="1000" className="bg-light">
      {props.number}
      &nbsp; - &nbsp;
      <FormattedQuestion question={props.question} />
    </td>
  </tr>
);

const ScaleRow = props => (
  <tr>
    {props.scaleItems.map((item, scaleOffset) => (
      <ScaleItem
        key={scaleOffset}
        group={props.group}
        item={item}
        checked={item.value === props.scaleValue}
        onChange={props.onChange.bind(this)}
      />
    ))}
  </tr>
);

const ScaleItem = props => (
  <td className="text-center">
    {props.item.label}
    <br />
    <RadioBox
      group={props.group}
      value={props.item.value}
      checked={props.checked}
      onChange={props.onChange.bind(this, props.item.value)}
    />
    <div style={{ marginBottom: "2em" }} />
  </td>
);

const RadioBox = props => (
  <input
    type="radio"
    name={props.group}
    value={props.value}
    checked={props.checked}
    onChange={event => props.onChange(event.target.checked)}
  />
);

const FormattedQuestion = props => {
  let questionTitle = `${props.question.title}`;
  let parenthesesRegex = /(\([^()]*\))/g;
  let formattedTitle = questionTitle.replace(
    parenthesesRegex,
    `<span class="text-muted">$1</span>`
  );
  return <span dangerouslySetInnerHTML={{ __html: formattedTitle }} />;
};



// WEBPACK FOOTER //
// ./src/SubSectionTestPage.jsx